// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Overlay background */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5); /* Transparent black */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  /* Modal container */
  .modal-container {
    position: relative;
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    width: 100%;
    max-width: 75%;
    box-sizing: border-box;
  }
  
  /* Close icon styling */
  .modal-close-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }
  
  /* Optional padding when isClosable is true */
  .modal-padding {
    padding-top: 40px;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/modal/modal.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC,EAAE,sBAAsB;IAC5D,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA,oBAAoB;EACpB;IACE,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,sBAAsB;EACxB;;EAEA,uBAAuB;EACvB;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;EACjB;;EAEA,6CAA6C;EAC7C;IACE,iBAAiB;EACnB","sourcesContent":["/* Overlay background */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5); /* Transparent black */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n  }\n  \n  /* Modal container */\n  .modal-container {\n    position: relative;\n    background-color: white;\n    padding: 20px;\n    border-radius: 8px;\n    width: 100%;\n    max-width: 75%;\n    box-sizing: border-box;\n  }\n  \n  /* Close icon styling */\n  .modal-close-icon {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    cursor: pointer;\n  }\n  \n  /* Optional padding when isClosable is true */\n  .modal-padding {\n    padding-top: 40px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
